import React, { useState, useRef } from 'react';

interface ZoomableImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
}

const ZoomableImage = ({ src, className, ...props }: ZoomableImageProps) => {
  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const imageRef = useRef<HTMLImageElement>(null);

  const handleMouseMove = (e: React.MouseEvent) => {
    if (imageRef.current) {
      const rect = imageRef.current.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      setPosition({ x, y });
    }
  };

  const handleWheel = (e: React.WheelEvent) => {
    e.preventDefault();
    setZoom((prevZoom) =>
      Math.min(Math.max(prevZoom + e.deltaY * -0.01, 1), 3),
    );
  };

  return (
    <div className="flex flex-col items-center">
      <div
        className="overflow-hidden"
        onMouseMove={handleMouseMove}
        onWheel={handleWheel}
      >
        <img
          ref={imageRef}
          alt="Zoomable"
          style={{
            transform: `scale(${zoom})`,
            transformOrigin: `${position.x}% ${position.y}%`,
          }}
          src={src}
          className={`transition-transform duration-300 ${className}`}
          {...props}
        />
      </div>
    </div>
  );
};

export default ZoomableImage;
